import { defineMessages } from '@edx/frontend-platform/i18n';
const messages = defineMessages({
  registrationFormMarketingOptInLabel: {
    id: 'registration.form.marketing.opt.in.label',
    defaultMessage: 'I agree that edX may send me marketing messages',
    description: 'Label for option to opt in for marketing emails on registration form'
  }
});
export default messages;
//# sourceMappingURL=messages.js.map